import gql from 'graphql-tag';

const deleteServiceMutation = gql`
mutation deleteService($_id: String!, $companyId: String!){
  deleteService(_id: $_id, companyId: $companyId)
}
`;

export default deleteServiceMutation;
